import React from "react";

import { faArrowsToLine } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { inCompanionMode } from "~/lib/utils";
import { useRecordingState } from "~/localRecording/useRecordingState";
import { Button } from "~/ui/button/Button";

export function DesktopTitleBar() {
	const { isActive } = useRecordingState();

	// The additional version check can go away once all users have updated to the new desktop app version.
	if (inCompanionMode && !navigator.userAgent.includes("FellowCompanionMode/0.0.1")) {
		return (
			<div className="flex flex-row justify-end items-center h-8 mx-1" style={{ "app-region": "drag" }}>
				{isActive && (
					<Button
						variant="tertiary"
						size="slim"
						className="text-(--secondaryTextColor)"
						style={{ "app-region": "no-drag" }}
						// eslint-disable-next-line react/jsx-no-bind
						onClick={() => window.CompanionModeAPI?.collapseIntoHandle()}
					>
						Collapse&nbsp;
						<FontAwesomeIcon icon={faArrowsToLine} />
					</Button>
				)}
			</div>
		);
	}
	return null;
}
